import { render, staticRenderFns } from "./PopupNewComponentForm.vue?vue&type=template&id=26e15f54"
import script from "./PopupNewComponentForm.vue?vue&type=script&lang=js"
export * from "./PopupNewComponentForm.vue?vue&type=script&lang=js"
import style0 from "./PopupNewComponentForm.vue?vue&type=style&index=0&id=26e15f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports